import React from 'react';
import { Award, Car, Smile, Globe } from 'lucide-react';
import { stats } from '../data/mockData';

const iconMap = {
  award: Award,
  car: Car,
  smile: Smile,
  globe: Globe
};

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section">
      <div className="section-header">
        <div className="section-line gold" />
        <h2 className="section-title">¿POR QUÉ ELEGIRNOS?</h2>
        <div className="section-line gold" />
      </div>
      <div className="stats-grid">
        {stats.map((stat) => {
          const IconComponent = iconMap[stat.icon];
          return (
            <div key={stat.id} className="stat-card">
              <div className="stat-icon-wrapper">
                <IconComponent size={28} color="#FFD700" />
              </div>
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyChooseUs;
